import React, { useState, useEffect, useRef } from "react";
import GetRecentPublications from "../../../utils/database/GetRecentPublications";
import Loader from "../../general/Loader";
import PublicationCards from "./PublicationCards";
import "./Publications.css";
import CognexLogo from "../../general/CognexLogo";
import useUserDetails from "../../../utils/auth/UserDetails";
import { Box } from "@mui/material";

const MAX_DESCRIPTION_LENGTH = 100;

const Publications = ({ selectedFilters, onChatSelect, searchValue }) => {
    const [publications, setPublications] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedPublication, setSelectedPublication] = useState(null);
    const userDetails = useUserDetails();


    const prevFiltersRef = useRef({ category: null, subCategory: null });

    const fetchPublications = async (category, subCategory) => {
        // Convert "all" to null

        const formattedCategory = category === "all" ? null : category;
        const formattedSubCategory = subCategory === "all" ? null : subCategory;

        // Ensure category and subcategory are defined (not empty)
        if (category === undefined || subCategory === undefined) return;

        try {
            setIsLoading(true);
            const fetchedPublications = await GetRecentPublications(null, formattedCategory, formattedSubCategory, userDetails?.userId, userDetails?.username);

            setPublications(fetchedPublications);
        } catch (error) {
            setError("Failed to fetch publications. Please try again.");
            setPublications([]);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        const { category, subCategory } = selectedFilters;
        const prevFilters = prevFiltersRef.current;


        if (category && subCategory && (category !== prevFilters.category || subCategory !== prevFilters.subCategory)) {
            prevFiltersRef.current = { category, subCategory };
            fetchPublications(category, subCategory);
        }
    }, [selectedFilters]);

    const truncateDescription = (description) => {
        return description.length > MAX_DESCRIPTION_LENGTH
            ? description.slice(0, MAX_DESCRIPTION_LENGTH) + "..."
            : description;
    };

    return (
        <div className="publications-main">
            {/* Sticky Header */}
            <div className="publications-header">
                <div className="header-container">
                    <div className="h-banner">
                        <h2>
                            Published Chats {" "}
                         
                        </h2>
                    </div>
                    <div>
                        <p>Explore all user-published chats by selecting a category and subcategory.
                            Filter through various discussions and view detailed conversations shared by users</p>
                    </div>
                </div>
            </div>

            {/* Scrollable Content */}
            <Box
                sx={{ height: '100%', width: '100%',overflow: 'hidden'}}
            >
                {isLoading ? (
                    <div className="center-content">
                        <Loader />
                    </div>
                ) : error ? (
                    <div className="center-content">
                        <p>{error}</p>
                    </div>
                ) : !selectedFilters.category || !selectedFilters.subCategory ? (
                    <div className="empty-state">
                        <div className="empty-card">
                            <h2 className="empty-title">No Publications to Display</h2>
                            <p className="empty-message">
                                Please select both <strong>Category</strong> and <strong>Subcategory</strong> to view the available publications.
                            </p>
                        </div>
                    </div>
                ) : publications.length > 0 ? (
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',                        // 1 card per row on mobile
                            sm: 'repeat(2, 1fr)',            // 2 cards per row on small screens
                            md: 'repeat(3, minmax(250px, 1fr))', // 3 cards per row on medium and up
                            xl: 'repeat(4, minmax(250px, 1fr))', // 3 cards per row on medium and up
                        },
                        gap: 2,
                        width: '100%',
                        height: '100%',
                        padding: 2,
                        overflowY:'scroll'
                    }}>
                        {publications.map((publication) => (
                            <PublicationCards
                                key={publication.chatId}
                                publication={publication}
                                truncateDescription={truncateDescription}
                                onInfoClick={setSelectedPublication}
                                onViewChat={onChatSelect}
                                searchValue={searchValue}
                            />
                        ))}
                    </Box>
                ) : (
                    <div className="center-content">
                        <p>No publications found</p>
                    </div>
                )}
            </Box>
        </div>

    );
};

export default Publications;
